// useCommentPanel
// ---------------
// Tiny custom hook bundling the state for the comment / files slide-in
// panels on the request-detail page, plus a global Escape-key listener
// that closes the comment panel.
//
// Extracted from RequestDetail.jsx (Phase D). Behaviour is identical to
// the previous inline state + effect.
// TypeScript source — useCommentPanel.js is a thin re-export stub.

import React, { useState } from "react";

export function useCommentPanel() {
  const [showCommentPanel, setShowCommentPanel] = useState(false);
  const [showFilesPanel, setShowFilesPanel] = useState(false);

  React.useEffect(function () {
    function handleEsc(e: KeyboardEvent) {
      if (e.key === "Escape") {
        setShowCommentPanel(false);
      }
    }
    window.addEventListener("keydown", handleEsc);
    return function () {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return {
    showCommentPanel,
    setShowCommentPanel,
    showFilesPanel,
    setShowFilesPanel,
  };
}
